import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between gap-4" }
const _hoisted_3 = { class: "flex flex-row items-center justify-evenly gap-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "URL", -1)
const _hoisted_5 = { class: "flex flex-row items-center justify-center" }

import Popover from '@/components/ui/popover/Popover.vue';
import PopoverTrigger from '@/components/ui/popover/PopoverTrigger.vue';
import PopoverContent from '@/components/ui/popover/PopoverContent.vue';
import Label from '@/components/ui/label/Label.vue';
import Input from '@/components/ui/input/Input.vue';
import { onMounted, PropType, ref } from 'vue';
import { Check, Link } from 'lucide-vue-next';
import Separator from './ui/separator/Separator.vue';
import Button from './ui/button/Button.vue';
import { get, set } from '@vueuse/core';
import Progress from './ui/progress/Progress.vue';
import { ImageUpload } from '@/http/customerSession';
import { validateBase64 } from '@/lib/formValidation';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImagePopover',
  props: {
    "modelValue": {
  type: Object as PropType<ImageUpload | undefined>,
  required: false,
  default: undefined
},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const url = ref<string | undefined>();
const hasUrlError = ref<boolean>(false);
const hasUploadError = ref<boolean>(false);
const openDialog = ref(false);
const progress = ref<number | undefined>(undefined);

const image = _useModel<ImageUpload | undefined>(__props, "modelValue");

const uploadFile = (uploadEvent: Event) => {
  uploadEvent.preventDefault();
  const input = uploadEvent.target as HTMLInputElement;
  const file: File | undefined = input.files ? input.files[0] : undefined;

  if (file) {
    const reader = new FileReader();

    reader.onloadstart = () => {
      set(progress, 0);
    };

    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        set(progress, Math.round(event.loaded / event.total) * 100);
      }
    };

    reader.onloadend = function (e: ProgressEvent<FileReader>) {
      const base64EncodedImage = (e.target?.result as string)?.split(',')?.at(-1);
      if (!validateBase64(base64EncodedImage)) {
        set(progress, undefined);
        hasUploadError.value = true;
        return;
      }
      set(image, {
        ...(get(image) ?? {}),
        imageContent: base64EncodedImage,
        imageSourceChoice: 'BASE64',
        imageContentType: file?.type as string
      });
      set(hasUploadError, false);
      set(progress, 100);
      setTimeout(() => {
        set(progress, undefined);
        set(openDialog, false);
      }, 500);
    };

    reader.readAsDataURL(file);
  } else {
    set(progress, undefined);
    hasUploadError.value = true;
  }
};

onMounted(() => {
  set(hasUrlError, false);
  set(hasUploadError, false);
  set(progress, undefined);
  set(image, undefined);
  set(url, undefined);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popover, {
    open: openDialog.value,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((openDialog).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(PopoverTrigger, { "as-child": "" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(PopoverContent, { class: "w-80 mr-2" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Label, { for: "url" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    _createVNode(_unref(Link)),
                    _hoisted_4
                  ])
                ]),
                _: 1
              }),
              _createVNode(Input, {
                "model-value": url.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((url).value = $event)),
                id: "url",
                name: "url",
                type: "text",
                placeholder: "Endereço da imagem",
                class: _normalizeClass(["col-span-2 h-8", {
              'border-red-500': hasUrlError.value,
              'placeholder:text-red-500': hasUrlError.value
            }])
              }, null, 8, ["model-value", "class"]),
              _createVNode(Button, {
                type: "button",
                variant: "default",
                size: "icon",
                class: "shadow-sm",
                onClick: _cache[1] || (_cache[1] = () => {
              if (url.value === undefined || url.value?.trim() === '' || url.value?.includes('?')) {
                hasUrlError.value = true;
                return;
              }
              image.value = {
                imageContent: url.value,
                imageSourceChoice: 'URL'
              };
              openDialog.value = false;
              hasUrlError.value = false;
            })
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Check))
                ]),
                _: 1
              })
            ]),
            _createVNode(Separator, {
              class: "my-4",
              label: "Ou"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                id: "uploadFile",
                name: "uploadFile",
                class: "border-0",
                type: "file",
                accept: "image/*",
                onChange: uploadFile
              }, null, 32),
              _createElementVNode("label", {
                for: "uploadFile",
                class: _normalizeClass(["btn-1 w-full py-1.5", {
              'border-red-500 bg-red-500': hasUploadError.value
            }])
              }, " Carregar ", 2)
            ]),
            _createVNode(Progress, {
              class: _normalizeClass([{ 'invisible': progress.value === undefined }, "w-full"]),
              modelValue: progress.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((progress).value = $event))
            }, null, 8, ["class", "modelValue"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["open"]))
}
}

})